import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-fifteen',
  templateUrl: './home-fifteen.component.html',
  styleUrls: ['./home-fifteen.component.scss']
})
export class HomeFifteenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
